import React from 'react';
import ListItem from '@wix/da-ds/pkg/List/ListItem';
import GallectionCover from './GallectionCover';
var GallectionListItem = function (_a) {
    var gallection = _a.gallection, isSelected = _a.isSelected, isDisabled = _a.isDisabled, control = _a.control, showSuffixOnlyOnHover = _a.showSuffixOnlyOnHover, suffix = _a.suffix, subLabel = _a.subLabel, onChange = _a.onChange, onClick = _a.onClick;
    return (React.createElement(ListItem, { isSelected: isSelected, isDisabled: isDisabled, control: control, showSuffixOnlyOnHover: showSuffixOnlyOnHover, suffix: suffix, label: gallection.name, subLabel: subLabel, name: gallection.name, prefix: React.createElement(GallectionCover, { gallection: gallection }), fillContainerWidth: true, onChange: onChange &&
            (function (isSelectedNew) {
                return onChange({
                    folderId: gallection.folderId,
                    isSelected: isSelectedNew,
                });
            }), onClick: onClick && (function () { return onClick(gallection.folderId); }) }));
};
GallectionListItem.displayName = 'GallectionListItem';
export default GallectionListItem;
//# sourceMappingURL=GallectionListItem.js.map